<div class="postit-popover-body" cdkDrag [cdkDragFreeDragPosition]="dragPosition" cdkDragHandle>
  <!-- <div class="postit-handle" cdkDragHandle>
    <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
      <path
        d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
      </path>
      <path d="M0 0h24v24H0z" fill="none"></path>
    </svg>
  </div> -->
   <div class="row">
    <div class="col-12"><b>{{message.from?.username ?? message.data.from_user}}</b></div>
  </div>
  <!-- <div class="row">
    <div class="col-12"><b>{{title}}</b></div>
  </div> -->
  <div class="row">
    <div class="col-12" [innerHtml]="body"></div>
  </div>
  <div class="row" style="padding: 10px;">
    <button  type="button" class="btn btn-primary btn-sm" (click)="setRead()">Segna come Letto</button>
  </div>
</div>